import { createSlice } from '@reduxjs/toolkit';
import {KeycloakUser, User} from '../../types/user';
import {KeycloakConverter} from '../../converters/KeycloakConverter';
import {decode} from '../../utils/jwt';

interface UserSessionSlice {
    token: string;
    user: User | null;
    userPhoto: string;
    kkUser: KeycloakUser | null;
}

const initialState: UserSessionSlice = {
    token: '',
    user: null,
    userPhoto: '',
    kkUser: null
};

const userSessionSlice = createSlice({
    name: 'userSession',
    initialState,
    reducers: {
        storeToken: (state, action) => {
            const token = action.payload;

            if (token) {
                const decodedToken = decode(token);
                state.token = token;
                state.kkUser = KeycloakConverter.convertFromKkTokenToKeycloakUser(decodedToken);
            }
        },
        storeUser: (state, action) => {
            const user: User = action.payload;

            if (user) {
                state.user = user;
            }

        },
        storeUserPhoto: (state, action) => {
            if (action.payload) {
                state.userPhoto = action.payload;
            }
        },
        removeUserProfilePhoto: (state) => {
            state.userPhoto = '';
        },
    },
});

export default userSessionSlice.reducer;

export const { storeToken, storeUser, storeUserPhoto, removeUserProfilePhoto  } = userSessionSlice.actions;

export const selectToken = (state: any) => state.userSession.token;
export const selectUser = (state: any) => state.userSession.user;
export const selectUserPhoto = (state: any) => state.userSession.userPhoto;
export const selectKkUser = (state: any) => state.userSession.kkUser;

export const selectAccountType = (state: any) => state.userSession.user?.accountType;
